<!--入库报表-->
<template>
	<div>
		<div class="content">
			<h3>入库报表</h3>
			<div class="item">
				<el-form ref="form" :model="form" inline :rules="rules" label-width="100px">
					<el-form-item label="入库单号" prop="workId">
						<el-input  v-model="form.workId"></el-input>
					</el-form-item>
                    <el-form-item label="商品名称" prop="productName">
						<el-input placeholder="全部商品" :value="form.productName" @focus="productfocus"></el-input>
					</el-form-item>
					<el-form-item label="入库库房" prop="kufang">
						<el-input :value="form.kufang" ></el-input>
					</el-form-item>
					<el-form-item label="入库日期" prop="date">
                        <el-date-picker
                        v-model="form.date"
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
				</el-form>
				<span style="margin: 0 0 20px 100px;">
                    <el-button type="primary" @click="SelintoData">搜 索</el-button>
					<el-button @click="restForm" type="warning">重 置</el-button>
				</span>
			</div>
            <el-dialog
			title="选择商品"
			:visible.sync="productVisible"
			width="600px">
                <el-table :data="productData" highlight-current-row>
                    <el-table-column align="center" width="80" property="DataId"></el-table-column>
                    <el-table-column align="center" width="80" property="Productcode" label="商品编号"></el-table-column>
                    <el-table-column align="center" width="200" property="Productname" label="商品名称"></el-table-column>
                    <el-table-column align="center" width="200" label="操作">
                        <template slot-scope="scope">
                             <el-button type="primary" @click="confirm(scope)">选 择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
		</div>
		<div class="item">
			<el-table :data="tableData" highlight-current-row border >
				<el-table-column align="center" property="id"   label="入库单号"></el-table-column>
				<el-table-column align="center" property="num"  label="入库时间"></el-table-column>
				<el-table-column align="center" property="name" label="入库类型"></el-table-column>
				<el-table-column align="center" property="name" label="商品名称"></el-table-column>
				<el-table-column align="center" property="name" label="商品规格"></el-table-column>
				<el-table-column align="center" property="name" label="计划数量"></el-table-column>
				<el-table-column align="center" property="name" label="实际数量"></el-table-column>
				<el-table-column align="center" property="name" label="入库库房"></el-table-column>
				<el-table-column align="center" property="name" label="订单状态"></el-table-column>
				<el-table-column align="center" property="name" label="详情"></el-table-column>
			</el-table>
			<el-pagination
			background
			@current-change="handleCurrentChange"
			layout="total,prev, pager, next,jumper"
			:total="pageNum"
			:page-size="10">
			</el-pagination>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				workId:'',
				productnum:'',
				productName:'',
				kufang:'',
				date:'',
			},
			rules: {
        		date:[
          			{ required: true, message: '请选择时间' }
        		]
			},
			productData:[],
			stroeData:[],
			dealerData:[],
			DeliveryType:[{
				type:'XSCK',
				storage:"销售出库"
			},{
				type:'XHCK',
				storage:"销毁出库"
			},{
				type:'DBCK',
				storage:"调拨出库"
			}],
			tableData: [],
			productVisible: false,
			storeVisible: false,
			dealerVisible: false,
			pageNum:0,
		};
	},
	mounted : function(){
		this.getProduct()
		this.getStore()
		this.getDealer()
	},
	methods: {
		getProduct(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		productfocus(){//获取商品
			this.productVisible=true;
		},
		productconfirm(scope){ //选中商品
			this.form.OutboundOrder.Productcode = scope.row.Productcode;
			this.form.productForm.Productname = scope.row.Productname;
			this.productVisible = false
		},
		setProductNull(){
			this.form.OutboundOrder.Productcode = '';
			this.form.productForm.Productname = '';
		},

		getStore(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Store.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.stroeData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		storefocus(){//获取仓库
			this.storeVisible=true;	
		},
		storeconfirm(scope){ //选中仓库
			this.form.OutboundOrder.ShipperId = scope.row.StoreCode;
			this.form.StoreName = scope.row.StoreName;
			this.storeVisible = false
		},
		setStoreNull(){
			this.form.OutboundOrder.ShipperId = '';
		},

		getDealer(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Dealer.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.dealerData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		},
		dealerfocus(){//获取经销商
			this.dealerVisible=true;
		},
		dealerconfirm(scope){ //选中仓库
			this.form.OutboundOrder.ReceiverId = scope.row.DealerId;
			this.form.DealerName = scope.row.DealerName;
			this.dealerVisible = false
		},
		setDealerNull(){
			this.form.OutboundOrder.ReceiverId = '';
		},

		restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
			this.form.OutboundOrder.Productcode = '';
			this.form.productForm.Productname = '';
			this.form.OutboundOrder.ReceiverId = '';
			this.form.OutboundOrder.ShipperId ='';
		},


		SelintoData(){
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/intoData.ashx',
				params: {
					action:"SelintoData",
					CID:user.QyNum,
					form:this.form
				}
				}).then(res=>{
				if(res.Code==0){
					this.tableData=res.Data;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/intoData.vue